/* eslint-disable import/prefer-default-export */
import Translations from '@helpers/translations'
import { BUILD, LEG, ORDERED_OPTIONS, SIZE } from '@consts/index'
import { FilterOption } from 'types/filters'

export type OptionType =
  | 'waist'
  | 'build'
  | 'inches'
  | 'length'
  | 'chest'
  | 'cut'
  | 'size'
  | 'trousers'
  | 'shorts'
  | 'tops'
  | 'shortsleg'
  | 'swimshortsleg'
  | 'leg'

type OptionLabel =
  | 'Waist'
  | 'Build'
  | 'Inches'
  | 'Length'
  | 'Chest'
  | 'Cut'
  | 'Size'
  | 'Trousers'
  | 'Shorts'
  | 'Tops'
  | 'Shorts Leg'
  | 'Swims Leg'
  | 'Trunks Leg'
  | 'Leg'

export function getOptionTypeLabel({
  type,
  multi = false,
  productType = ''
}: {
  type: OptionType
  multi?: boolean
  productType?: string
}): OptionLabel {
  const optionType = type.toLowerCase()
  const isSocks = /socks/.test(productType.toLowerCase())

  if (optionType === SIZE.toLowerCase() && !isSocks) {
    return Translations.localise('collection.filters.chest') as OptionLabel
  }

  if (optionType === LEG.toLowerCase()) {
    return Translations.localise(
      `collection.filters.${multi ? 'trousers' : 'leg'}`
    ) as OptionLabel
  }

  return Translations.localise(
    `collection.filters.${optionType}`
  ) as OptionLabel
}

export function getCollectionFiltersState(
  selectedFilterOptions: FilterOption[],
  fitAttribute: string,
  selectedOption: string
) {
  const newFilterOptions = [...selectedFilterOptions]

  const filterOptionindex = selectedFilterOptions.findIndex(
    option => option.type?.toLowerCase() === fitAttribute?.toLowerCase()
  )

  const newFilterOption = {
    type: fitAttribute,
    position:
      1 +
      ORDERED_OPTIONS.findIndex(
        fitType => fitAttribute === fitType.toLowerCase()
      ),
    value: selectedOption.replace(BUILD, '').trim()
  }
  if (filterOptionindex === -1) {
    newFilterOptions.push(newFilterOption)
  } else if (
    newFilterOptions[filterOptionindex].value?.toLowerCase() ===
    selectedOption?.toLowerCase()
  ) {
    newFilterOptions.splice(filterOptionindex, 1)
  } else {
    newFilterOptions[filterOptionindex] = { ...newFilterOption }
  }
  return newFilterOptions
}
